export default [
  {
    path: "/about",
    name:
      "企业介绍|企业培训咨询数字化转型 | 找光华、科学经营™方法论、分拆对™工作法",
    component: () => import("@/views/about/index.vue"),
    meta: {
      title: "光华介绍"
    }
  },
  {
    path: "/co-creation-emba",
    name: "共创会EMBA|培养专业的老板-香港光华管理学院实战EMBA",
    component: () => import("@/views/about/emba-overview.vue"),
    meta: {
      title: "共创会EMBA"
    }
  },
  {
    path: "/teacher",
    name: "光华师资|上百名师大咖、行业专家、庞大的师资库、丰富的培训管理经验",
    component: () => import("@/views/about/teacher/index.vue"),
    meta: {
      title: "师资团队"
    }
  },
  {
    path: "/teacher-detail/:id?",
    name: "光华师资|上百名师大咖、行业专家、庞大的师资库、丰富的培训管理经验",
    component: () => import("@/views/about/teacher/detail.vue"),
    meta: {
      title: "讲师详情"
    }
  },
  {
    path: "/case",
    name: "客户案例|客户成功、客户陪跑",
    component: () => import("@/views/about/case/index.vue"),
    meta: {
      title: "客户案例"
    }
  },
  {
    path: "/case-detail/:id?",
    name: "客户案例|客户成功、客户陪跑",
    component: () => import("@/views/about/case/detail.vue"),
    meta: {
      title: "案例详情"
    }
  },
  {
    path: "/news",
    name:
      "光华动态|光华活动资讯：线下交流思想碰撞、共同成长；光华大事记、二十余年专业企业经营研究，高维发展、全面赋能、长期陪跑",
    component: () => import("@/views/about/news/index.vue"),
    meta: {
      title: "光华动态"
    }
  },
  {
    path: "/news-detail/:id?",
    name:
      "光华动态|光华活动资讯：线下交流思想碰撞、共同成长；光华大事记、二十余年专业企业经营研究，高维发展、全面赋能、长期陪跑",
    component: () => import("@/views/about/news/detail.vue"),
    meta: {
      title: "内容详情"
    }
  },
  {
    path: "/course",
    name: "公开课列表",
    component: () => import("@/views/about/course/index.vue"),
    meta: {
      title: "公开课列表"
    }
  },
  {
    path: "/course-detail/:id?",
    name: "课程详情",
    component: () => import("@/views/about/course/detail.vue"),
    meta: {
      title: "课程详情"
    }
  }
];
